import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html'
})
export class AppFooter {
  public currentYear: number;
  
  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/app-footer/app-footer.component.ts